import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-public-branding',
  templateUrl: './public-branding.html',
  styleUrl: './public-branding.scss',
  imports: [
    CommonModule,
    RouterLink,
  ],
})
export class PublicBranding {

  @Input() title?: string;
  @Input() center: boolean = false;

}
